var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 295.82 295.82",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 295.82 295.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m154.871,69.605c-10.441-3.48-22.621,0-31.322,6.96-8.701,6.96-13.921,17.401-13.921,29.582 0,5.22 3.48,8.701 8.701,8.701 5.22,0 8.701-3.48 8.701-8.701 0-5.22 1.74-12.181 6.96-15.661 5.22-3.48 10.441-5.22 17.401-3.48 8.701,1.74 13.921,8.701 15.661,15.661 1.74,8.701 0,15.661-6.96,20.882-13.921,10.441-20.882,26.102-20.882,41.763 0,5.22 3.48,8.701 8.701,8.701 5.22,0 8.701-3.48 6.96-8.701 0-10.441 6.96-20.882 15.661-27.842 12.181-10.441 17.401-24.362 13.921-38.283-3.481-15.661-15.661-26.102-29.582-29.582z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.95,210.555c-1.74,1.74-1.74,5.22-1.74,6.96 0,1.74 0,3.48 1.74,5.22 1.74,1.74 5.22,3.48 6.96,3.48 1.74,0 5.22-1.74 5.22-3.48 1.74,0 3.48-3.48 3.48-5.22 0-3.48-1.74-5.22-3.48-6.96-3.48-3.481-8.7-3.481-12.18,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.91,0C66.124,0,0,66.124,0,147.91s66.124,147.91,147.91,147.91s147.91-66.124,147.91-147.91S229.696,0,147.91,0z     M147.91,278.419c-71.345,0-130.509-59.164-130.509-130.509S76.565,17.401,147.91,17.401S278.419,76.565,278.419,147.91    S219.255,278.419,147.91,278.419z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/questionmark.b8e6a7fe799d1aec8e859765c911b17e.svg";
export { ForwardRef as ReactComponent };